import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const magento = defineConnector({
  identifier: "magento",
  name: "Magento",
  tagLine: "Open-source e-commerce platform",
  logo,
  protocol: "http",
  tags: ["engineering", "data"],
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create a Magento or Adobe Commerce access token",
      items: [
        {
          kind: "markdown",
          content:
            "Adobe Commerce REST APIs use bearer tokens. Create an integration token or admin access token in your Magento or Adobe Commerce instance, then copy it for use in 3B.",
        },
      ],
    },
    {
      title: "Enter your Magento details",
      items: [
        {
          kind: "baseUrl",
          label: "Store URL",
          required: true,
          placeholder: "https://commerce.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/rest/V1/store/storeConfigs`,
  },
});
